module.exports = __webpack_public_path__ + "static/img/satlogojpg.db2a9ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/satlogojpg.jpg
// module id = xOu/
// module chunks = 1